/**
 * @fileoverview Cubic Hits Module for InstantSearch.js.
 * Renders hits in a cubic format using a custom widget in InstantSearch.js.
 * This function generates a grid of cubes representing each hit with different interactive faces.
 */

import { highlight } from "instantsearch.js/es/helpers";

/**
 * Renders cubic hits into the specified container.
 * This function is used as a connector for a custom hits widget in InstantSearch.js.
 * It generates a 3D cube representation for each hit, with different information on each face.
 *
 * @param {Object} renderOptions - The options and utilities provided by InstantSearch.js for rendering.
 * @param {string|null} type - An optional type parameter to specify the type of cubic hits, e.g., 'global_network'.
 */
const CubicHits = (renderOptions, type = null) => {
    const { hits, widgetParams } = renderOptions;
    widgetParams.container.innerHTML = `
        <div class="grid gap-5 grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
            ${hits.map((hit) => `
                <div class="grid-cube-container mx-auto my-8 md:my-12">
                    <a href="${(type === 'global_network' ? (hit.permalink ? hit.permalink : '') : hit.website)}" 
                        target="${type === 'global_network' ? '_self' : '_blank'}"
                        >
                        <div class="grid-cube">
                            <figure class="face front bg-pxl-alabaster-80">
                                    <div class="flex h-full flex-wrap">
                                        <div class="p-10 w-full h-full flex flex-col gap-2 justify-center items-center">
                                            <img class="max-h-[150px] mt-auto w-auto justify-self-stretch self-center" src="${hit.featured_image ?? '/wp-content/themes/wbcsd/src/img/alogo-2.webp'}" alt="logo">
                                            <div class="mt-auto">
                                                <span class="relative underline underline-offset-4 text-body-regular font-normal text-black">
                                                    ${highlight({ attribute: 'post_title', hit })}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                            </figure>
                            <figure class="face back"></figure>
                            <figure class="face left"></figure>
                            <figure class="face right">
                                <img class="h-full w-full" src="${hit.cube_image_url ?? '/wp-content/themes/wbcsd/src/img/robert-lukeman.jpg'}" alt="">
                            </figure>
                            <figure class="face top"></figure>
                            <figure class="face bottom bg-primary-orange flex justify-center items-center">
                                <svg class="h-[80px] w-auto" width="39" height="38" viewBox="0 0 39 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.72211 19.0002H31.1138" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M19.918 7.80432L31.1138 19.0002L19.918 30.196" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </figure>
                        </div>
                    </a>
                </div>
            `).join('')}
        </div>
    `;
};

export default CubicHits;